export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensors",
                        observations: "Observacions",
                        modelling: "Modelatge",
                        mapFeatures: "Característiques del mapa",
                        output: "Exportació & Informes",
                        setUp: "Configuració",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: {
            long: { singular: 'milisegon', plural: 'milisegons' },
            short: { singular: 'ms', plural: 'ms' }
        },
        seconds: {
            long: { singular: 'segon', plural: 'segons' },
            short: { singular: 'seg.', plural: 'seg.' }
        },
        minutes: {
            long: { singular: 'minut', plural: 'minuts' },
            short: { singular: 'min.', plural: 'min.' }
        },
        hours: {
            long: { singular: 'hora', plural: 'hores' },
            short: { singular: 'hr.', plural: 'hrs.' }
        },
        days: { long: { singular: 'dia', plural: 'dies' }, short: { singular: 'dia', plural: 'dies' } },
        weeks: {
            long: { singular: 'setmana', plural: 'setmanas' },
            short: { singular: 'sem.', plural: 'sems.' }
        },
        months: {
            long: { singular: 'mes', plural: 'mesos' },
            short: { singular: 'mes', plural: 'mesos' }
        },
        quarters: { long: { singular: 'trimestre', plural: 'trimestres' }, short: { singular: 'tri.', plural: 'tris.' } },
        years: { long: { singular: 'any', plural: 'anys' }, short: { singular: 'any', plural: 'anys' } }
    },
    timezone: 'Fus horari',
    custom: 'esmenat',
    period: 'període',
};
